import { MutableRefObject } from 'react';

import {
  Button,
  ModalContainer,
  ModalLayoutCenter,
} from '@kanda-libs/ks-design-library';

import { CANT_FIND_BANK_MODAL_ID } from './constants';
import useCantFindBankModal from './useCantFindBankModal';

const CantFindBankModal: React.FunctionComponent = function () {
  const { onClick, disabled } = useCantFindBankModal();
  return (
    <ModalContainer id={CANT_FIND_BANK_MODAL_ID} opacity={40}>
      {({ id, handleClose, ref }) => (
        <ModalLayoutCenter
          id={id}
          onClose={handleClose}
          ref={ref as MutableRefObject<HTMLDivElement>}
          className="w-11/12 md:w-160"
        >
          <div className="flex flex-col gap-y-4">
            <div className="w-full pr-8">
              <h2 className="text-16-24-em">Can&apos;t find your bank?</h2>
            </div>
            <h3 className="text-14-22">
              Unfortunately, not all banks support open banking payments as of
              yet. We are constantly keeping an eye out for more banks to add to
              the above list, via our partner Stripe. If you think this is a
              mistake, please reach out to Kanda and we will see how we can
              help. Otherwise, you will need to return to the checkout and
              select a different payment method
            </h3>
            <Button.Text
              id="cant-find-bank-return"
              label="Return to Checkout"
              onClick={() => {
                handleClose();
                onClick();
              }}
              disabled={disabled}
            />
          </div>
        </ModalLayoutCenter>
      )}
    </ModalContainer>
  );
};

export default CantFindBankModal;
